import { selector } from 'recoil';
import { CreditCardService } from 'api';
const getCreditCardFee = selector({
  key: 'getCreditCardFee',
  get: async () => {
    try {
      return await CreditCardService.getCreditCardFee();
    } catch (e) {
      console.error(`${e}: Could not fetch Credit Card Fee`);
    }
  }
});
export default getCreditCardFee;